module.exports = __webpack_public_path__ + "img/marta.355b9b64.png";